import type { AuditLogResource } from '../../store/modules/merchant/types';

const auditLogResourceLabels: Record<AuditLogResource, string> = {
  configs: 'Configs',
  callbacks: 'Callbacks',
  whitelists: 'Whitelists',
  credentials: 'Credentials',
  urls: 'URLs',
  webhooks: 'Webhooks',
  agenticSettings: 'Agent Hub',
  portalUserAccess: 'Portal user access',
};

export const getAuditLogResourceLabel = (resource: AuditLogResource) =>
  auditLogResourceLabels[resource];
